module.exports = __webpack_public_path__ + "img/sign_btn.8937e6b0.png";